module.exports = __webpack_public_path__ + "img/2_2.7783fb8a.jpg";